import React, { useState } from 'react'
import TicketsAdmin from './TicketsAdmin'
import ProxyInfo from './ProxyInfo'

const AdminDashboard = (props) => {
    const [selectedProxyId, setSelectedProxyId] = useState('')

    const handleProxyIdSelect = (proxyId) => {
        setSelectedProxyId(proxyId)
    }

    return (
        <div style={{
            display: 'flex',
            gap: 'var(--spacing-xl)',
            width: '100%',
            minHeight: '100vh',
            background: 'var(--dark-bg)',
            padding: 'var(--spacing-xl)'
        }}>
            
            {/* Левая колонка - Tickets (очень широкая) */}
            <div style={{
                flex: '3',
                minWidth: '0' // Предотвращает переполнение
            }}>
                <TicketsAdmin 
                    apiClient={props.apiClient} 
                    onProxyIdSelect={handleProxyIdSelect}
                />
            </div>

            {/* Правая колонка - Proxy Info (узкая) */}
            <div style={{
                flex: '1',
                minWidth: '350px', // Минимальная ширина для удобства
                maxWidth: '400px'  // Максимальная ширина
            }}>
                <ProxyInfo 
                    apiClient={props.apiClient} 
                    selectedProxyId={selectedProxyId}
                />
            </div>

        </div>
    )
}

export default AdminDashboard
